<template>
  <div />
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ConnectionMonitoring',
  data () {
    return {
      namespace: 'Components.ConnectionMonitoring'
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    successMessage () {
      this.showAlert({
        type: 'success',
        message: this.$t(`${this.namespace}.success`),
        timeout: 6000
      })
    },

    errorMessage () {
      this.showAlert({
        type: 'error',
        message: this.$t(`${this.namespace}.error`),
        timeout: 6000
      })
    }
  },
  mounted () {
    window.addEventListener('online', this.successMessage, false)
    window.addEventListener('offline', this.errorMessage, false)
  },
  beforeMount () {
    window.removeEventListener('online', this.successMessage, false)
    window.removeEventListener('offline', this.errorMessage, false)
  }
}
</script>
